(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Lotus", [], factory);
	else if(typeof exports === 'object')
		exports["Lotus"] = factory();
	else
		root["Lotus"] = factory();
})(self, function() {
return 